import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** Route guard — only allows role === "superadmin". Non-superadmins are
 *  sent home (they have nothing to see here); unauthenticated users are
 *  sent to the DEDICATED /superadmin/login page, not the tenant /login,
 *  so the tenant sign-in screen never surfaces Super Admin chrome. */
export default function SuperAdminRoute({ children }) {
    const { user } = useAuth();
    const location = useLocation();
    if (user === undefined) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-[#050b1c]">
                <div className="font-mono text-xs uppercase tracking-widest text-white/50">
                    Authenticating…
                </div>
            </div>
        );
    }
    if (user === null) {
        return (
            <Navigate
                to="/superadmin/login"
                replace
                state={{ from: location.pathname + location.search }}
            />
        );
    }
    if (user.role !== "superadmin") return <Navigate to="/" replace />;
    return children;
}
